import { useCallback, useMemo, useState } from 'react'

export interface UseEditorSelectionResult {
  selectedIds: string[]
  isSelected: (id: string) => boolean
  toggle: (id: string) => void
  clear: () => void
}

export function useEditorSelection(): UseEditorSelectionResult {
  const [set, setSet] = useState<Set<string>>(() => new Set())
  const selectedIds = useMemo(() => Array.from(set), [set])
  const toggle = useCallback((id: string) => {
    setSet((prev) => {
      const next = new Set(prev)
      if (next.has(id)) next.delete(id)
      else next.add(id)
      return next
    })
  }, [])
  const clear = useCallback(() => setSet(new Set()), [])
  return {
    selectedIds,
    isSelected: useCallback((id: string) => set.has(id), [set]),
    toggle,
    clear,
  }
}
